module.exports = __webpack_public_path__ + "static/media/menu.20600769.svg";